import { formatNZD } from '@sparknz/journeys-common';

import { shopCartFragment$data } from '__generated__/shopCartFragment.graphql';
import {
  DeviceOfferDetail,
  PaymentOption,
  Price,
} from 'journey/productDetails/typings';

export type ProductPrice =
  | DeviceOfferDetail
  | PaymentOption
  | Price
  | DeviceOfferDetail['associatedPrices'][0];
type CartItem = shopCartFragment$data['bundles'][0]['items'][0];
type CartSummary = shopCartFragment$data['summaries'][0];
export type CartItemPrice =
  | CartItem['prices'][0]['basePrice']
  | CartItem['prices'][0]['effectivePrice'];

interface CartItemPriceProps {
  cartItemPrice: CartItemPrice;
  isBusiness: boolean;
  isIncluded?: boolean;
}

interface CartSummaryPriceProps {
  cartSummary?: CartSummary;
  isBusiness: boolean;
}

export const INCLUDED_COST_TEXT = 'Included';

export const getProductPrice = (
  productPrice: ProductPrice,
  isBusiness: boolean,
  isBasePrice: boolean,
): number => {
  if (!productPrice) {
    return null;
  }

  const {
    basePrice,
    basePriceExcludingTax,
    effectivePrice,
    effectivePriceExcludingTax,
  } = productPrice;

  if (isBasePrice) {
    return isBusiness ? basePriceExcludingTax : basePrice;
  }

  return isBusiness ? effectivePriceExcludingTax : effectivePrice;
};

export function getCostText(
  cost: number | undefined,
  isIncluded?: boolean,
  isBusiness?: boolean,
) {
  if (cost === 0 || isIncluded) {
    return INCLUDED_COST_TEXT;
  }
  if (cost) {
    return `${formatNZD(cost)}${isBusiness ? '*' : ''}`;
  }

  return '';
}

export const getCartItemPrice = ({
  cartItemPrice,
  isBusiness,
  isIncluded,
}: CartItemPriceProps) => {
  return `${getCostText(
    isBusiness ? cartItemPrice?.taxExclusiveValue : cartItemPrice?.value,
    isIncluded,
    isBusiness,
  )}`;
};

export const getCartTotalPrice = ({
  cartSummary,
  isBusiness,
}: CartSummaryPriceProps) =>
  `${getCostText(
    isBusiness ? cartSummary?.taxExclusiveTotal : cartSummary?.total,
    false,
    isBusiness,
  )}`;
